const generateRows = (
  offices: CoreOfficeAddress[],
  onAction: (type: 'edit' | 'delete', office: CoreOfficeAddress) => void
): TableRow[] =>
  offices.map((office) => {
    const action: TableCellAction = {
      type: `action`,
      data: [
        {
          type: 'edit',
          linkData: {
            onClick: () => {
              onAction('edit', office);
            }
          }
        },
        {
          type: 'delete',
          linkData: {
            onClick: () => {
              onAction('delete', office);
            }
          }
        }
      ]
    };

    const visiblePostalCodes = office.postalCodes?.slice(0, 2) || [];
    const extraCount = (office.postalCodes?.length || 0) - visiblePostalCodes.length;

    const postalCodes: TableCellChip = {
      type: 'chip',
      data: [
        ...visiblePostalCodes.map((item) => ({
          text: item.postalCode,
          backgroundColor: '#d7d7d7'
        })),
        // Only add the extra chip if there are additional postal codes
        ...(extraCount > 0 ? [{ text: `+${extraCount}`, backgroundColor: '#d7d7d7' }] : [])
      ]
    };
    const payload: TableRow = {
      officeId: office.officeId ?? '',
      zooplaBranchId: office.zooplaBranchId ?? '',
      location: office.location ?? '',
      readEmail: office.readEmail ?? '',
      branchEmail: office.branchEmail ?? '',
      robotEmail: office.robotEmail ?? '',
      mortgageEmail: office.mortgageEmail ?? ' - ',
      valuationEmail: office.valuationEmail ?? ' - ',
      phone: office.phone ?? 'NA',
      supplierNumber: office.supplierNumber ?? '',
      postalCodes,
      type: office.type ?? 'none',
      origin: office.origin ?? '',
      source: office.source ?? '',
      introducerName: office.introducerName ?? '',
      introducerId: office.introducerId ?? '',
      introducerBranchName: office.introducerBranchName ?? '',
      introducerBranchId: office.introducerBranchId ?? '',
      appointmentNotificationEmail: office.appointmentNotificationEmail ?? '',
      evergladesApiKey: office.evergladesApiKey ?? '',
      action
    };
    return payload;
  });

export default generateRows;
